import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatINR } from "@/lib/api";

const ProductCard = ({ product, index = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-6%" }}
    transition={{ duration: 0.8, delay: (index % 3) * 0.08, ease: [0.19, 1, 0.22, 1] }}
  >
    <Link to={`/product/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
      <div className="img-zoom aspect-[3/4] bg-ink-800 relative">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
        <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-widest text-bone bg-ink/60 backdrop-blur px-2 py-1">
          {product.category}
        </span>
      </div>
      <div className="flex items-start justify-between mt-4 gap-4">
        <h3 className="font-serif text-2xl text-bone leading-tight group-hover:text-crimson transition-colors duration-300">
          {product.name}
        </h3>
        <p className="font-mono text-sm text-ash whitespace-nowrap pt-1">{formatINR(product.price)}</p>
      </div>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash/60 mt-1">{product.fabric}</p>
    </Link>
  </motion.div>
);

export default ProductCard;
